//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlFormat } from 'date-fns'

export default {
  props: {
    img: {
      type: String,
      default: null
    },
    badgeTitle: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    postDate: {
      type: String,
      default: null
    },
    postTitle: {
      type: String,
      default: null
    },
    postContent: {
      type: String,
      default: null
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    slug: {
      type: String,
      default: null
    },
    postFooter: {
      type: Boolean,
      default: false
    },
    postbanner: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getPlainText () {
      const input = this.postContent
      if (input && input.length) {
        return input.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '').replace(/<[^>]+?>/g, '').replace(/\s+/g, ' ').replace(/ /g, ' ').replace(/>/g, ' ')
      }
      return ''
    }
  },
  methods: {
    getDate (postDate) {
      try {
        return intlFormat(new Date(postDate), {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
      } catch (err) {
        console.log(err)
        if (typeof postDate === 'string') {
          return postDate.substring(0, 10)
        }
        return ''
      }
    }
  }
}
